import { render, staticRenderFns } from "./dev.vue?vue&type=template&id=1f5b029e&scoped=true"
import script from "./dev.vue?vue&type=script&lang=js"
export * from "./dev.vue?vue&type=script&lang=js"
import style0 from "./dev.vue?vue&type=style&index=0&id=1f5b029e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b029e",
  null
  
)

export default component.exports